import { useState, useRef, useCallback } from "react";
export const useStatefulRef = (initialValue) => {
    const [state, setState] = useState(initialValue);
    const ref = useRef(initialValue);
    const setValues = useCallback((val) => {
        ref.current = val;
        setState(val);
    }, []);
    return { state, ref, setValues };
};
//# sourceMappingURL=useStatefulRef.js.map